// import { Input, Typography, Space, FormInstance, message, Spin, Col, Row } from 'antd';
// import { useEffect, useState } from 'react';
// import { CheckCircleFilled, CloseCircleOutlined, EditOutlined } from '@ant-design/icons';
// import RenderFormItem from './FormItems';
// import { FormColumnConfig, MasterConfigs } from '../../interfaces/entity';
// import { useDispatch } from 'react-redux';
// import { getData } from '../../actions/apiCall';
// import { putData } from '../../actions/developer';
// import { transformData } from './Form';
// import get from 'lodash/get';
// import set from 'lodash/set';
// import { fetchWithCache } from '../../actions/auth';
// import { useSelector } from 'react-redux';

// interface EditableFormBlockProps {
//     config: MasterConfigs;
//     id: string;
//     form: FormInstance;
// }

// const getIds = (data: Record<string, any>) => {
//     const ids: Record<string, any> = {};
//     Object.keys(data).forEach((key) => {
//         if (data[key] && typeof data[key] === 'object' && '_id' in data[key]) {
//             ids[key] = data[key]._id;
//         } else {
//             ids[key] = data[key];
//         }
//     });
//     return ids;
// }

// const EditableFormBlock: React.FC<EditableFormBlockProps> = ({ config, id, form }) => {
//     const [data, setData] = useState<Record<string, any>>({});
//     const [editingField, setEditingField] = useState<string | null>(null);
//     const [loading, setLoading] = useState(true);
//     const payloadData = useSelector(({ app }) => app?.cache[`${id}`]?.data);
//     const dispatch = useDispatch();

//     useEffect(() => {
//         if (payloadData) {
//             let formData = transformData(payloadData);
//             setData(formData);
//             form.setFieldsValue(getIds(formData));
//             setLoading(false);
//         } else {
//             fetchData();
//         }
//     }, [id, payloadData]);


//     const fetchData = async () => {
//         if (!id) return;
//         setLoading(true);
//         try {
//             dispatch(
//                 fetchWithCache({
//                     key: id,
//                     url: config.api() + '/' + id,
//                     query: {},
//                     cacheDuration: 0.1 * 60 * 1000,
//                     reloadData: true
//                 })
//             )
//         } catch (error) {
//             message.error('Failed to load data');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleSave = async (field: string | string[], value: any) => {
//         try {
//             if (form.getFieldError(field).length > 0) {
//                 message.error('Please fix the errors before saving');
//                 return;
//             }
//             const payload: any = {};
//             const actualValue = value && typeof value === 'object' && '_id' in value ? value._id : value;
//             set(payload, field, actualValue);
//             const resData = await dispatch(putData(config.api() + '/' + id, payload));
//             if (resData) {
//                 dispatch({
//                     type: 'API_SUCCESS',
//                     payload: { key: id, data: resData },
//                 });
//                 const payload = transformData(resData);
//                 setData(payload);
//                 form.setFieldsValue(getIds(payload));
//             }
//             message.success(`${Array.isArray(field) ? field.join('.') : field} updated`);
//             setEditingField(null);
//         } catch (error) {
//             message.error('Failed to save');
//         }
//     };

//     if (loading) return <Spin className="my-4" />;

//     const columns = config.getFormColumns();

//     return (
//         <Row gutter={[16, 12]} className='overflow-x-auto'>
//             {columns.map((column: FormColumnConfig) => {
//                 const field = column.name;
//                 const fieldKey = Array.isArray(field) ? field.join('.') : field;
//                 const isEditing = editingField === fieldKey;
//                 const span = column.span || 12;
//                 const fieldValue = get(data, field);

//                 if (!column.type) {
//                     return column.render ? (
//                         <Col key={fieldKey} span={span}>
//                             {column.render(fieldValue, data)}
//                         </Col>
//                     ) : null;
//                 }

//                 return (
//                     <Col key={fieldKey} md={24} sm={24} lg={24} xl={span}>
//                         <div className="flex items-start gap-x-4 group">
//                             <div className="text-right whitespace-nowrap min-w-[140px] text-gray-500 mt-1">
//                                 {column.label}
//                             </div>
//                             <div
//                                 className={`flex-1 text-left border max-w-[300px] sm:w-auto md:w-auto border-transparent rounded-md ${isEditing ? '' : 'group-hover:border-gray-300 px-2 py-[2px] cursor-pointer'} transition`}
//                                 onClick={() =>
//                                     !column.commonProps?.disabled && !isEditing && setEditingField(fieldKey)
//                                 }
//                             >
//                                 {isEditing ? (
//                                     <Space>
//                                         <RenderFormItem
//                                             column={{
//                                                 ...column,
//                                                 label: '',
//                                                 className: 'min-w-[180px] sm:w-auto md:w-auto xl:w-[300px]',
//                                                 commonProps: {
//                                                     onChange: (e: any) => {
//                                                         const val = e?.target?.value ?? e;
//                                                         form.setFieldValue(field, val);
//                                                     },
//                                                 },
//                                             }}
//                                             combo={config.combo}
//                                             form={form}
//                                         />
//                                         <CheckCircleFilled
//                                             className="text-green-500 text-xl mt-1 cursor-pointer"
//                                             onClick={() => handleSave(field, get(form.getFieldsValue(), field))}
//                                         />
//                                         <CloseCircleOutlined
//                                             className="text-red-500 text-xl mt-1 cursor-pointer"
//                                             onClick={() => {
//                                                 setEditingField(null);
//                                                 form.setFieldValue(field, fieldValue ?? '');
//                                             }}
//                                         />
//                                     </Space>
//                                 ) : (
//                                     <div className="flex items-center justify-between py-[2px]">
//                                         <Typography.Text className="text-black font-medium">
//                                             {
//                                                 column?.render ? column.render(fieldValue, data) || <i className="text-gray-400">—</i>
//                                                     : (typeof fieldValue === 'object' && fieldValue?.name) ||
//                                                     fieldValue ||
//                                                     <i className="text-gray-400">—</i>
//                                             }
//                                         </Typography.Text>
//                                         {!column?.commonProps?.disabled && <EditOutlined
//                                             className="ml-2 text-gray-400 cursor-pointer opacity-0 group-hover:opacity-100 transition"
//                                         />}
//                                     </div>
//                                 )}
//                             </div>
//                         </div>
//                     </Col>
//                 );
//             })}
//         </Row>
//     );
// };

// export default EditableFormBlock;





import { Input, Typography, Space, FormInstance, message, Spin, Col, Row, Button, Form } from 'antd'; // ✅ NEW: added Button
import { useEffect, useState } from 'react';
import { CheckCircleFilled, CloseCircleOutlined, EditOutlined } from '@ant-design/icons';
import RenderFormItem from './FormItems';
import { FormColumnConfig, MasterConfigs } from '../../interfaces/entity';
import { useDispatch } from 'react-redux';
import { getData } from '../../actions/apiCall';
import { postData, putData } from '../../actions/developer';
import { transformData } from './Form';
import get from 'lodash/get';
import set from 'lodash/set';
import { fetchWithCache } from '../../actions/auth';
import { useSelector } from 'react-redux';

interface EditableFormBlockProps {
    config: MasterConfigs;
    id: string;
    form: FormInstance;
    addNew?: boolean; // ✅ NEW: add flag
    onClose?: () => void;
    hideButtons?: boolean; // Hide Save/Cancel buttons when used in drawer
}

const getIds = (data: Record<string, any>) => {
    const ids: Record<string, any> = {};
    Object.keys(data).forEach((key) => {
        if (data[key] && typeof data[key] === 'object' && '_id' in data[key]) {
            ids[key] = data[key]._id;
        } else {
            ids[key] = data[key];
        }
    });
    return ids;
}

const EditableFormBlock: React.FC<EditableFormBlockProps> = ({ config, id, form, addNew = false, onClose, hideButtons = false }) => { // ✅ use flag
    const [data, setData] = useState<Record<string, any>>({});
    const [editingField, setEditingField] = useState<string | null>(addNew ? '__all__' : null); // ✅ edit mode for all
    const [loading, setLoading] = useState(true);
    const payloadData = useSelector(({ app }) => app?.cache[`${id}`]?.data);
    const dispatch = useDispatch();

    useEffect(() => {
        if (addNew) {
            setLoading(false); // skip fetch
            return;
        }

        if (payloadData) {
            let formData = transformData(payloadData);
            setData(formData);
            form.setFieldsValue(getIds(formData));
            setLoading(false);
        } else {
            fetchData();
        }
    }, [id, payloadData]);

    const fetchData = async () => {
        if (!id) return;
        setLoading(true);
        try {
            dispatch(
                fetchWithCache({
                    key: id,
                    url: config.api() + '/' + id,
                    query: {},
                    cacheDuration: 0.1 * 60 * 1000,
                    reloadData: true
                })
            )
        } catch (error) {
            message.error('Failed to load data');
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async (field: string | string[], value: any) => {
        try {
            if (form.getFieldError(field).length > 0) {
                message.error('Please fix the errors before saving');
                return;
            }

            // Call onSubmit if provided in config (for validation)
            if (config.onSubmit) {
                try {
                    const allValues = { ...data, [Array.isArray(field) ? field[0] : field]: value };
                    await config.onSubmit(id, allValues);
                } catch (error) {
                    // Validation failed, don't proceed with save
                    return;
                }
            }

            const payload: any = {};
            const actualValue = value && typeof value === 'object' && '_id' in value ? value._id : value;
            set(payload, field, actualValue);
            const resData = await dispatch(putData(config.api() + '/' + id, payload));
            if (resData) {
                dispatch({
                    type: 'API_SUCCESS',
                    payload: { key: id, data: resData },
                });
                const payload = transformData(resData);
                setData(payload);
                form.setFieldsValue(getIds(payload));
            }
            message.success(`${Array.isArray(field) ? field.join('.') : field} updated`);
            setEditingField(null);
        } catch (error) {
            message.error('Failed to save');
        }
    };

    const handleFullSave = async () => { // ✅ NEW
        try {
            const values = await form.validateFields();
            const payload: any = {};
            config.getFormColumns().forEach((column) => {
                const field = column.name;
                const val = get(values, field);
                set(payload, field, val);
            });
            if (id) {
                const resData = await dispatch(putData(config.api() + '/' + id, payload));
                if (resData && onClose) {
                    onClose();
                }
            } else {
                const resData = await dispatch(postData(config.api(), payload));
                if (resData && onClose) {
                    onClose();
                }
            }
        } catch (error) {
            message.error('Failed to save');
        }
    };

    const handleCancel = () => { // ✅ NEW
        form.setFieldsValue(getIds(data));
        setEditingField(null);
    }

    if (loading) return <Spin className="my-4" />;

    const columns = config.getFormColumns();

    return (
        <>
            <Row gutter={[16, 12]} className='overflow-x-auto'>
                {columns.map((column: FormColumnConfig) => {
                    const field = column.name;
                    const fieldKey = Array.isArray(field) ? field.join('.') : field;
                    const isEditing = editingField === '__all__' || editingField === fieldKey;
                    const span = column.span || 12;
                    const fieldValue = get(data, field);

                    if (!column.type) {
                        return column.render ? (
                            <Col key={fieldKey} span={span}>
                                {column.render(fieldValue, data)}
                            </Col>
                        ) : null;
                    }


                    // if (column.type === "form") {
                    //     return (
                    //         <Col key={fieldKey} span={24}>
                    //             <div className="flex flex-col gap-3">
                    //                 <div className="text-gray-600 font-medium">{column.label}</div>
                    //                 <Form.List name={fieldKey}>
                    //                     {(fields, { add, remove }) => (
                    //                         <>
                    //                             {fields.map(({ key, name, ...restField }) => (
                    //                                 <div key={key} className="border p-3 rounded-md mb-2">
                    //                                     <Row gutter={12}>
                    //                                         {column.form?.map((subCol: FormColumnConfig) => (
                    //                                             <Col key={subCol.name} span={subCol.span || 12}>
                    //                                                 <RenderFormItem
                    //                                                     column={{
                    //                                                         ...subCol,
                    //                                                         label: subCol.label,
                    //                                                         name: [name, subCol.name],
                    //                                                     }}
                    //                                                     form={form}
                    //                                                     combo={config.combo}
                    //                                                 />
                    //                                             </Col>
                    //                                         ))}
                    //                                     </Row>
                    //                                     {!addNew && (
                    //                                         <div className="flex justify-end gap-3 mt-2">
                    //                                             <CheckCircleFilled
                    //                                                 className="text-green-500 text-xl cursor-pointer"
                    //                                                 onClick={() =>
                    //                                                     handleSave(
                    //                                                         fieldKey,
                    //                                                         form.getFieldValue(fieldKey)
                    //                                                     )
                    //                                                 }
                    //                                             />
                    //                                             <CloseCircleOutlined
                    //                                                 className="text-red-500 text-xl cursor-pointer"
                    //                                                 onClick={() => {
                    //                                                     form.setFieldValue(fieldKey, fieldValue ?? []);
                    //                                                     setEditingField(null);
                    //                                                 }}
                    //                                             />
                    //                                             <Button
                    //                                                 danger
                    //                                                 type="text"
                    //                                                 size="small"
                    //                                                 onClick={() => remove(name)}
                    //                                             >
                    //                                                 Remove
                    //                                             </Button>
                    //                                         </div>
                    //                                     )}
                    //                                 </div>
                    //                             ))}
                    //                             <Button type="dashed" block onClick={() => add()}>
                    //                                 + Add {column.label}
                    //                             </Button>
                    //                         </>
                    //                     )}
                    //                 </Form.List>
                    //             </div>
                    //         </Col>
                    //     );
                    // }

                    if (column.type === "form") {
                        return (
                            <Col key={fieldKey} span={24} className='pb-4'>
                                <div className="flex items-start gap-x-4 group max-w-3/4 ml-4">
                                    <div
                                        className={`flex-1 ${isEditing ? '' : 'group-hover:border-gray-300 px-2 py-[2px] cursor-pointer'} transition`}
                                        onClick={() => !isEditing && setEditingField(fieldKey)}
                                    >
                                        {isEditing ? (
                                            <>
                                                <Form.List name={fieldKey} initialValue={fieldValue || [{}]}>
                                                    {(fields, { add, remove }) => (
                                                        <>
                                                            {fields.map(({ key, name }, index) => (
                                                                <div key={key} className="border p-3 rounded-md mb-2">
                                                                    <Row gutter={12}>
                                                                        {column.form?.map((subCol: FormColumnConfig) => (
                                                                            <Col key={subCol.name} span={subCol.span || 12}>
                                                                                <RenderFormItem
                                                                                    column={{
                                                                                        ...subCol,
                                                                                        label: subCol.label,
                                                                                        name: [name, subCol.name], // nested path
                                                                                    }}
                                                                                    form={form}
                                                                                    combo={config.combo}
                                                                                />
                                                                            </Col>
                                                                        ))}
                                                                    </Row>
                                                                    <div className="flex justify-end mt-2">
                                                                        <Button
                                                                            danger
                                                                            type="text"
                                                                            size="small"
                                                                            disabled={index === 0 && fields.length === 1}
                                                                            onClick={() => remove(name)}
                                                                        >
                                                                            Remove
                                                                        </Button>
                                                                        {index == fields.length - 1 && <Button
                                                                            type="link"
                                                                            size="small"
                                                                            onClick={() => add()}
                                                                        >
                                                                            Add
                                                                        </Button>}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </>
                                                    )}
                                                </Form.List>
                                                {!addNew && <div className="flex justify-end gap-3 mt-3">
                                                    <CheckCircleFilled
                                                        className="text-green-500 text-xl cursor-pointer"
                                                        onClick={() =>
                                                            handleSave(fieldKey, form.getFieldValue(fieldKey))
                                                        }
                                                    />
                                                    <CloseCircleOutlined
                                                        className="text-red-500 text-xl cursor-pointer"
                                                        onClick={() => {
                                                            form.setFieldValue(fieldKey, fieldValue ?? []);
                                                            setEditingField(null);
                                                        }}
                                                    />
                                                </div>}
                                            </>
                                        ) : (
                                            <div className="flex flex-col gap-2 w-full">
                                                {Array.isArray(fieldValue) && fieldValue.length > 0 ? (
                                                    fieldValue.map((addr: any, idx: number) => (
                                                        <div
                                                            key={idx}
                                                            className="flex justify-between items-center border-b pb-1"
                                                        >
                                                            <Typography.Text>
                                                                <div className='flex gap-4'>
                                                                    {column.form.map((subCol: FormColumnConfig) => (
                                                                        <span key={subCol.name}>{subCol?.label} : <b>{subCol.render ? subCol.render(addr[subCol.name]) : addr[subCol.name]} </b> </span>
                                                                    ))}
                                                                </div>
                                                            </Typography.Text>
                                                            <EditOutlined className="ml-2 text-gray-400 cursor-pointer opacity-0 group-hover:opacity-100 transition" />
                                                        </div>
                                                    ))
                                                ) : (
                                                    <i className="text-gray-400">—</i>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </Col>
                        );
                    }



                    return (
                        <Col key={fieldKey} md={24} sm={24} lg={24} xl={span}>
                            <div className="flex items-start gap-x-4 group">
                                <div className="text-right whitespace-nowrap min-w-[140px] text-gray-500 mt-1">
                                    {isEditing && column?.rules && column?.rules?.find((ele: { required: boolean }) => ele?.required) && <span className="text-red-500">*</span>}  {column.label}
                                </div>
                                <div
                                    className={`flex-1 text-left border max-w-[300px] sm:w-auto md:w-auto border-transparent rounded-md ${isEditing ? '' : 'group-hover:border-gray-300 px-2 py-[2px] cursor-pointer'} transition`}
                                    onClick={() =>
                                        !column.commonProps?.disabled && !isEditing && setEditingField(fieldKey)
                                    }
                                >
                                    {isEditing ? (
                                        <Space>
                                            <RenderFormItem
                                                column={{
                                                    ...column,
                                                    label: '',
                                                    className: 'min-w-[180px] sm:w-auto md:w-auto xl:w-[300px]',
                                                    commonProps: {
                                                        onChange: (e: any) => {
                                                            const val = e?.target?.value ?? e;
                                                            form.setFieldValue(field, val);
                                                        },
                                                        disabled: column.commonProps?.disabled,
                                                    },
                                                }}
                                                combo={config.combo}
                                                form={form}
                                            />
                                            {!addNew && (
                                                <>
                                                    <CheckCircleFilled
                                                        className="text-green-500 text-xl mt-1 cursor-pointer"
                                                        onClick={() => handleSave(field, get(form.getFieldsValue(), field))}
                                                    />
                                                    <CloseCircleOutlined
                                                        className="text-red-500 text-xl mt-1 cursor-pointer"
                                                        onClick={() => {
                                                            setEditingField(null);
                                                            form.setFieldValue(field, fieldValue ?? '');
                                                        }}
                                                    />
                                                </>
                                            )}
                                        </Space>
                                    ) : (
                                        <div className="flex items-center justify-between py-[2px]">
                                            <Typography.Text className="text-black font-medium">
                                                {
                                                    column?.render ? column.render(fieldValue, data) || <i className="text-gray-400">—</i>
                                                        : (typeof fieldValue === 'object' && fieldValue?.name) ||
                                                        fieldValue ||
                                                        <i className="text-gray-400">—</i>
                                                }
                                            </Typography.Text>
                                            {!column?.commonProps?.disabled && <EditOutlined
                                                className="ml-2 text-gray-400 cursor-pointer opacity-0 group-hover:opacity-100 transition"
                                            />}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Col>
                    );
                })}
            </Row>

            {/* ✅ Show Save/Cancel button if addNew and not hiding buttons */}
            {addNew && !hideButtons && (
                <div className="mt-6 flex justify-end gap-4">
                    <Button type="default" onClick={handleCancel}>Cancel</Button>
                    <Button type="primary" onClick={handleFullSave}>Save</Button>
                </div>
            )}
        </>
    );
};

export default EditableFormBlock;

